<template>

  <component class="uk-button uk-width-1-1" :class="[color, uksize]" :is="type" :to="to" :color="color" :type="type">
    <slot>Submit</slot>
  </component>

</template>

<script>
export default {
  name: 'BitButton',
  computed: {
    type() {
      if (this.to) {
        return 'router-link'
      }
      return 'button'
    },
    uksize() {
      if(this.size) {
        if(this.size == 'small') {
          return 'uk-button-small'
        } else if(this.size == 'large') {
          return 'uk-button-large'
        } else if(this.size == 'fill') {
          return 'ba-button-fill'
        } else {
          return ''
        }
      }
      return ''
    }
  },
  props: {
    to: {
      required: false
    },
    color: {
      required: false,
      default: 'gold'
    },
    size: {
      require: false
    }
  }
}
</script>

<style scoped lang="less">
  @import "../../assets/less/theme.less";

  .uk-button {
    color: #fff !important;
    white-space: nowrap;

    &:disabled {
      background-color: transparent !important;
      border: 1px solid #999;
      color: #999 !important;
    }
  }
  .ba-button-fill {
    height: 100%;
  }
  .inverse {
    background-color: transparent;
    border: 1px solid #666;
    color: #666 !important;

    &:hover:not([disabled]) {
      border: 1px solid @ba-gold;
      color: @ba-gold !important;
    }
  }
  .gold {
    background-color: @ba-gold !important;

    &:hover:not([disabled]) {
      background-color: darken(@ba-gold, 5%) !important;
    }
  }
  .green {
    background-color: @ba-green !important;

    &:hover:not([disabled]) {
      background-color: darken(@ba-green, 5%) !important;
    }
  }
  .purple {
    background-color: @ba-purple !important;

    &:hover:not([disabled]) {
      background-color: darken(@ba-purple, 5%) !important;
    }
  }
  .red {
    background-color: @ba-red !important;

    &:hover:not([disabled]) {
      background-color: darken(@ba-red, 5%) !important;
    }
  }
  .transparent {
    color: #333 !important;
    background-color: transparent !important;
    border: none !important;

    &:hover:not([disabled]) {
      color: @ba-purple !important;
      background-color: inherit;
    }
  }
</style>
